/** Identifiants purs communs au brief DEV et aux deux Studios. */

/** Miroir du schema de champs, confronte a celui-ci par champs.test.mjs. */
export const FAMILLE_A_DECIDER = '@a-decider';

/** `Tarif / jour` -> `tarifJour`. @param {string} nom @returns {string} */
export function clefDeChamp(nom) {
  const mots = String(nom || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (mots.length === 0) return '';
  const [tete, ...suite] = mots;
  const clef =
    tete.toLowerCase() + suite.map((m) => m[0].toUpperCase() + m.slice(1).toLowerCase()).join('');
  return /^[a-z]/.test(clef) ? clef : `champ${clef[0].toUpperCase()}${clef.slice(1)}`;
}

/** `@a-decider/<id de porte>`. @param {string} porteId @returns {string} */
export function familleADeciderDe(porteId) {
  return `${FAMILLE_A_DECIDER}/${porteId}`;
}

/** @param {string} famille @returns {boolean} */
export function estFamilleADecider(famille) {
  const f = String(famille || '');
  return f === FAMILLE_A_DECIDER || f.startsWith(`${FAMILLE_A_DECIDER}/`);
}

/** L'id kebab-case propose depuis un libelle. @param {string} texte @returns {string} */
export function kebab(texte) {
  return String(texte || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * LES MOTS DU REGLAGE « AU CLIC SUR UNE FICHE » (`portes[].auClic`), ecrits une
 * fois pour le brief et pour les lignes du Studio d'une app lue : deux ecrans,
 * un seul vocabulaire.
 */
export const MOTS_AU_CLIC = Object.freeze({
  reglage: 'Au clic sur une fiche',
  fiche: 'Ouvrir la fiche',
  vue: "Vue d'arrivée du clic",
  arriveeLiee: 'Arrivée de la porte liée',
});

/**
 * LES MOTS DU REGLAGE « DANS LA NAVIGATION » (`portes[].navigation`), ecrits une
 * fois pour le brief et pour les lignes du Studio d'une app lue. `arrivee` et
 * `sansLien` disent pourquoi une porte ne peut pas quitter le menu : ce sont
 * les deux refus du schema (`appScreensSchema`).
 */
export const MOTS_NAVIGATION = Object.freeze({
  reglage: 'Dans la navigation',
  aide: 'Décochée : hors du menu, ouverte par un lien',
  arrivee: "Porte d'arrivée : toujours dans le menu",
  sansLien: 'Aucune porte ne la lie : reste dans le menu',
});

/**
 * LA VUE D'ARRIVEE QUE LE CLIC PREND QUAND ON CHOISIT UN LIEN : le Kanban si la
 * porte liee le monte (le geste « a la Odoo » pour lequel le reglage existe),
 * sinon son arrivee (`''`). Un seul endroit, pour le formulaire du brief et
 * pour les lignes du Studio d'une app lue (donc le MCP) : revenir a « Ouvrir
 * ses taches » apres « Ouvrir la fiche » retrouve le Kanban.
 * @param {readonly string[]} vuesDeLaPorteLiee @returns {string}
 */
export function vueParDefautDuClic(vuesDeLaPorteLiee) {
  return vuesDeLaPorteLiee.includes('core.kanban') ? 'core.kanban' : '';
}

/**
 * « Ouvrir ses tâches » : le choix qui entre dans la porte liee. L'initiale du
 * nom passe en minuscule, sauf sur un sigle (« CRM » reste « CRM »).
 * @param {string} nomDeLaPorte @returns {string}
 */
export function motOuvrirSes(nomDeLaPorte) {
  const nom = String(nomDeLaPorte || '').trim();
  const sigle = nom.length > 1 && nom[1] !== nom[1].toLowerCase();
  return `Ouvrir ses ${sigle ? nom : nom.charAt(0).toLowerCase() + nom.slice(1)}`;
}
